import { Type } from 'class-transformer';

import { AccountDto } from '@/src/models/AccountDto';

class MenuPermission {
  // "회원" : ["회원 관리", "회원 목록"]
  [key: string]: string[];
}

class Permission {
  @Type(() => MenuPermission)
  menuPermissions: MenuPermission[];
}

export class AdministratorDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  // 이름
  name: string;

  // 아이디(이메일과 동일)
  aId: string;

  // 핸드폰 번호
  phone: string;

  // 관리자 부서
  department: string;

  // 관리자 메뉴 권한
  @Type(() => Permission)
  permission: Permission;

  @Type(() => AccountDto)
  account: AccountDto;
}
